import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
export const refreshSession = () => {
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  return refreshing;
};
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    if (error.response?.status === 401 && !original._retry && !url.includes("/auth/")) {
      original._retry = true;
      try {
        await refreshSession();
        return api(original);
      } catch (e) {
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(error);
  }
);

const FIELD_IT = { name: "Nome e cognome", phone: "Telefono", address: "Indirizzo", description: "Descrizione merce", items: "Articoli", qty: "Quantità", price: "Prezzo",
  client_name: "Nome cliente", date: "Data", time: "Ora", amount: "Importo", title: "Titolo", password: "Password", username: "ID", transport: "Trasporto", assembly: "Montaggio", other_costs: "Altri costi", paid: "Somma versata" };

const describe = (d) => {
  const field = Array.isArray(d?.loc) ? [...d.loc].reverse().find((x) => typeof x === "string" && x !== "body") : null;
  return field ? `Campo mancante o non valido: ${FIELD_IT[field] || field}` : (typeof d?.msg === "string" ? d.msg : JSON.stringify(d));
};

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return [...new Set(detail.map(describe))].join(" · ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);

export const mapsUrl = (a) => {
  if (a.lat != null && a.lng != null) return `https://www.google.com/maps/dir/?api=1&destination=${a.lat},${a.lng}`;
  if (a.client_address) return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(a.client_address)}`;
  return null;
};

export const stopOf = (a) => (a.lat != null && a.lng != null ? `${a.lat},${a.lng}` : a.client_address || null);

export const routeUrl = (stops) => {
  const dest = encodeURIComponent(stops[stops.length - 1]);
  const way = stops.slice(0, -1).map(encodeURIComponent).join("|");
  return `https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=${dest}${way ? `&waypoints=${way}` : ""}`;
};

export const eur = (v) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(v) || 0);

export async function uploadImage(fileOrBlob, filename = "foto.jpg", kind = "") {
  const fd = new FormData();
  fd.append("file", fileOrBlob, fileOrBlob.name || filename);
  const { data } = await api.post(kind ? `/upload?kind=${kind}` : "/upload", fd);
  return data.path;
}

export const toISODate = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};
